import 'promise-polyfill/lib/polyfill';
import ShopifyCollectionProvider from './providers/ShopifyCollectionProvider';

export default class CollectionService {
  constructor(type) {
    this._provider = null;
    switch (type.toLowerCase()) {
      case 'shopify': {
        this._provider = ShopifyCollectionProvider;
        break;
      }
      default:
        this._provider = ShopifyCollectionProvider;
    }
  }

  getCollection(handle) {
    return this._provider.getCollection(handle);
  }

  getCollectionProducts(handle) {
    return this._provider.getCollectionProducts(handle);
  }
}
